import React, { useState, useEffect } from 'react';
import './ColombianAddressInput.css';

const ColombianAddressInput = ({ 
  value, 
  onChange, 
  onValidationChange,
  name = "direccion",
  id = "direccion",
  label = "Dirección",
  placeholder = "Ej: C 73B 45 89 APTO 7",
  required = false
}) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  
  // Regex from backend
  const ADDRESS_REGEX = /^(C|K|D|T|V)\s\d{1,3}[A-Z]?\d?\s\d{1,3}[A-Z]?\d?\s\d{1,3}(\s(APTO|APT|CASA|INT|INTERIOR|TORRE|PISO|LOCAL|BLOQUE|OFICINA)\s?[A-Z0-9-]+)?$/;

  // Auto-clean function
  const cleanAndFormat = (input) => {
    let text = input.toUpperCase();
    text = text.replace(/[#N°,-]/g, ' ');
    text = text.replace(/NO\./g, ' ');
    text = text.replace(/\s+/g, ' ').trimStart(); // Allow trailing spaces while typing
    return text;
  };

  const handleChange = (e) => {
    const cleaned = cleanAndFormat(e.target.value);
    setInternalValue(cleaned);
    
    // Check validation on typing
    validate(cleaned);
    
    if (onChange) {
      // Simulate event
      onChange({ target: { name, value: cleaned } });
    }
  };

  const validate = (val) => {
    const trimmed = val.trim();
    if (!trimmed && !required) {
      setIsValid(true);
      setErrorMessage('');
      if (onValidationChange) onValidationChange(true);
      return;
    }
    
    if (!trimmed && required) {
      setIsValid(false);
      setErrorMessage('La dirección es obligatoria');
      if (onValidationChange) onValidationChange(false);
      return;
    }

    const valid = ADDRESS_REGEX.test(trimmed);
    setIsValid(valid);
    setErrorMessage(valid ? '' : 'Formato inválido. Use C/K/D/T/V + Nros. Ej: K 42B2 84C1 79 APTO 7');
    if (onValidationChange) onValidationChange(valid);
  };

  const handleBlur = () => {
    const fullyTrimmed = internalValue.trim();
    setInternalValue(fullyTrimmed);
    validate(fullyTrimmed);
    if (onChange) {
      onChange({ target: { name, value: fullyTrimmed } });
    }
  };

  useEffect(() => {
    if (value !== undefined && value !== internalValue) {
      const cleaned = cleanAndFormat(value);
      setInternalValue(cleaned);
      validate(cleaned);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className={`colombian-address-input ${!isValid ? 'has-error' : ''}`}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        type="text"
        id={id}
        name={name}
        className={`app-input ${isValid ? 'is-valid' : 'is-invalid'}`}
        value={internalValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
      />
      {errorMessage && (
        <span className="address-error-message">
          {errorMessage}
        </span>
      )}
      <div className="address-helper">
        Tipos de vía permitidos: C, K, D, T, V. Sin "#" ni "-". 
      </div>
    </div>
  );
};

export default ColombianAddressInput;
